import { Consume } from "../../../Context/Consumer";
import React, { Component } from "react";
import {
  PlayerListContext,
  TransContext,
  TeamDataContext,
  FixturesContext,
  ConstraintsContext,
} from "../../../Context";
import {
  getTrans,
  customTracking,
  setDropDownHeight,
  getDefaultPlySort,
  getPageName,
} from "../../../common";
import { Scrollbars } from "react-custom-scrollbars";
import config from "../../../common/config";
import OutsideNotifier from "../../../components/OutsideNotifier";

class WebSortByFIlter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSortByWeb: false,
    };
    this.playerSortByArr = config.sortByArr;
    /* this.defaultSortBy = JSON.parse(
      JSON.stringify(config.playerFiltersRaw)
    ).sortBy;
    this.defaultSortBy = getDefaultPlySort(
      this.props.ConstraintsData.data.matchdayId,
      config.WebConfig.sortKey
    ).sortBy; */
  }

  componentDidMount() {
    let budget = this.props.TeamData?.data?.budget;
    this.props.PlayerListData.setPlayerFilters(
      getDefaultPlySort(
        this.props.ConstraintsData.data.MatchdayNo,
        config.WebConfig.sortKey
      ),
      budget
    );
  }

  onSortOpen = (value) => {
    if (value != undefined) {
      this.setState({
        openSortByWeb: false,
      });
    } else {
      this.setState({
        openSortByWeb: !this.state.openSortByWeb,
      });
    }
  };

  setSortBy = (sort) => {
    let sortBy = sort;
    this.props.PlayerListData.playerListFilters.sortBy = sortBy.sortId;
    this.props.PlayerListData.playerListFilters.sortByObj = {
      ...sortBy,
      selected: true,
    };
    let budget = this.props.TeamData.data.budget;
    this.props.PlayerListData.setPlayerFilters(
      this.props.PlayerListData.playerListFilters,
      budget
    );
    customTracking(
      "Select Sort By Filter - " +
        (config.sortByArrTracking[sort]
          ? config.sortByArrTracking[sort]
          : sort),
      getPageName()
    );
    this.setState({
      openSortByWeb: false,
    });
  };

  //   resetSortBy = (e) => {
  //     e.stopPropagation();
  //     this.props.PlayerListData.playerListFilters.sortBy = this.defaultSortBy;
  //     let budget = this.props.TeamData.data.budget;
  //     this.props.PlayerListData.setPlayerFilters(
  //       this.props.PlayerListData.playerListFilters,
  //       budget
  //     );
  //   };

  render() {
    const { openSortByWeb } = this.state;
    const { setSortBy, onSortOpen, playerSortByArr } = this;
    let { PlayerListData, TransData } = this.props;
    let trans = TransData.data;
    let handler = {
      handler: () => {
        onSortOpen(false);
      },
    };

    let { sortBy, sortByObj } = PlayerListData.playerListFilters;

    return (
      <div className="si-form__control">
        <OutsideNotifier {...handler}>
          <div className="si-lbl">
            <span>{getTrans(trans, "sort_by", "Sort By")}</span>
          </div>
          <div
            className={"si-drpDwn " + (openSortByWeb ? "si-active" : "")}
            onClick={() => onSortOpen()}
          >
            <div
              className={`si-drpDwn__value ${
                sortByObj?.selected ? "si-picked" : ""
              }`}
            >
              <span>{getTrans(trans,sortByObj?.labelTrans) ? getTrans(trans,sortByObj?.labelTrans) : getTrans(trans,"value","Price")}</span>
              <select
                onChange={(e) => {
                  const sort = playerSortByArr.filter(
                    (a) => a.label === e.target.value
                  );
                  setSortBy(...sort);
                }}
              >
                {playerSortByArr.map((sort) => {
                  return (
                    <option
                      key={sort.id}
                      // onClick={() => {
                      //   setSortBy(sort);
                      // }}
                      className={sortByObj?.id === sort.id ? "si-active" : ""}
                    >
                      {getTrans(trans, sort.labelTrans, sort.label)}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="si-drpDwn__list">
                <Scrollbars className="si-scroll_js">
              <ul>
                  {playerSortByArr.map((sort) => {
                    return (
                      <li
                        key={sort.id}
                        onClick={() => {
                          setSortBy(sort);
                        }}
                        className={sortByObj?.id === sort.id ? "si-active" : ""}
                      >
                        {getTrans(trans, sort.labelTrans, sort.label)}
                      </li>
                    );
                  })}
              </ul>
                </Scrollbars>
            </div>
          </div>
        </OutsideNotifier>
      </div>
    );

    return (
      <div
        className={
          this.state.openSortByWeb
            ? "si-dropdown__wrap si-dropdown--white si-show"
            : "si-dropdown__wrap si-dropdown--white"
        }
      >
        <div
          className={
            PlayerListData.playerListFilters.sortBy !== this.defaultSortBy
              ? "si-dropdown__btn si-curved si-selected"
              : "si-dropdown__btn si-curved "
          }
          onClick={() => this.onSortOpen()}
        >
          <div className="si-dropdown__txt">
            {getTrans(
              trans,
              PlayerListData.playerListFilters.sortBy,
              PlayerListData.playerListFilters.sortBy
            )}
          </div>
          <div className="si-dropdown__action">
            {PlayerListData.playerListFilters.sortBy !== this.defaultSortBy ? (
              <div
                onClick={(e) => {
                  this.resetSortBy(e);
                }}
                className="si-icon euro-cross-round"
              ></div>
            ) : null}
            <div className="si-dropdown__close euro-drop-down"></div>
          </div>
        </div>

        {this.state.openSortByWeb ? (
          <OutsideNotifier handler={() => this.onSortOpen(false)}>
            <ul
              className="si-dropdown__menu"
              style={setDropDownHeight(
                "sortByFilter",
                45,
                this.playerSortByArr.length
              )}
            >
              <Scrollbars className="si-scroll_js">
                {this.playerSortByArr.map((sortBy) => {
                  return (
                    <li
                      className={
                        PlayerListData.playerListFilters.sortBy == sortBy
                          ? "si-selected--tertiary"
                          : ""
                      }
                      onClick={() => {
                        this.setSortBy(sortBy);
                      }}
                      key={sortBy}
                    >
                      <a className="si-dropdown__item">
                        {getTrans(trans, sortBy, sortBy)}
                      </a>
                    </li>
                  );
                })}
              </Scrollbars>
            </ul>
          </OutsideNotifier>
        ) : null}
      </div>
    );
  }
}

export default Consume(WebSortByFIlter, [
  PlayerListContext,
  TransContext,
  TeamDataContext,
  FixturesContext,
  ConstraintsContext,
]);
